<template>
  <tr class="t-border-b hover:t-bg-orange-100 t-bg-gray-100">
    <td class="t-p-3 t-px-5">{{ claim.solution }}</td>
    <td class="t-p-3 t-px-5">
      <span v-if="claim.files.data.length">
        <li v-for="(file, index) in claim.files.data" :key="index">
          <a :href="'/customer-files/' + file.id">{{ file.name }}</a>
        </li>
      </span>
      <span v-else>No file</span>
    </td>
  </tr>
</template>

<script>
export default {
  name: "damage-claims-item",
  props: ["claim"]
};
</script>
